const EVENT_NAMES = Object.freeze({
  OPEN: 'mobile-nav:open',
  CLOSED: 'mobile-nav:close',
});

const Events = {
  Open: new Event(EVENT_NAMES.OPEN),
  Closed: new Event(EVENT_NAMES.CLOSED),
};

export { EVENT_NAMES, Events };
